import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AppstateLogOutResetMap } from './auth-state-models';

export enum AuthActionTypes {
  logInSuccess = '[Auth] LogIn success',
  logInFailed = '[Auth] LogIn fail',

  logOut = '[Auth] Logout started',
  logOutResetConcluded = '[Auth] A state concluded its logOut routine',

  setAuthLoading = '[Auth] Set Auth state loading',
  setIsAuthenticated = '[Auth] Set IsAuthenticated',
}

export const logInSuccess = createAction(
  AuthActionTypes.logInSuccess,
  props<{ isNewLogin: boolean }>(),
);

export const logInFailed = createAction(
  AuthActionTypes.logInFailed,
  props<{ error: HttpErrorResponse }>(),
);

export const logOut = createAction(AuthActionTypes.logOut);

export const logOutResetConcluded = createAction(
  AuthActionTypes.logOutResetConcluded,
  props<{ state: keyof AppstateLogOutResetMap }>(),
);

export const setAuthLoading = createAction(
  AuthActionTypes.setAuthLoading,
  props<{ loading: boolean }>(),
);

export const setIsAuthenticated = createAction(
  AuthActionTypes.setIsAuthenticated,
  props<{ isAuthenticated: boolean }>(),
);
